export enum AccountProviderIds {
  DEFAULT = 'password',
  GOOGLE = 'google.com',
  MICROSOFT = 'microsoft.com',
}
